import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Tooltip } from "antd";
import { MdOutlineFileDownload, MdPushPin } from "react-icons/md";
import { MdDelete, MdEdit } from "react-icons/md";
import { FaLock, FaLockOpen } from "react-icons/fa6";
import dayjs from "dayjs";
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  TiArrowUnsorted,
  TiArrowSortedUp,
  TiArrowSortedDown,
} from "react-icons/ti";
import ReactPaginate from "react-js-pagination";
import NoData from "../../../asserts/no data.png";
import ModalPopup from "../../Common/Modal/Modal";
import DocumentDeleteList from "./DocumentDelete";
import {
  GetDocumentsData,
  RequestOtpForViewSensitiveDocument,
  ValidateDocumentOtp,
  UpdateDocumentFavorite,
  UpdateDocumentSensitive,
  ValidateUpdateSensitiveStatusOtp,
  DeleteDocument,
  ValidateDeleteDocumentOtp,
} from "../../../Api/SuperAdminVault/Documents";
import DocumentOtpModal from "./DocumentOtpModal";
import ShareModal from "../ShareModal";
import {
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFileImage,
  FaFileAlt,
} from "react-icons/fa";
import { FaFileZipper } from "react-icons/fa6";
import { IoMdShareAlt } from "react-icons/io";

import { BsPinAngleFill } from "react-icons/bs";

const ITEMS_PER_PAGE = 10;

const fileTypeColor = (type) => {
  const t = String(type || "").toLowerCase();

  if (t.includes("pdf")) {
    return { bg: "bg-[#FD3434]", border: "border-[#FD3434]", label: "PDF" };
  }
  if(t.includes("x-zip-compressed")){
      return { bg: "bg-[#7C3AED]", border: "border-[#FD3434]", label: "ZIP" };
    }

  if (
    t.includes("spreadsheet") ||
    t.includes("excel") ||
    t.includes("xlsx") ||
    t.includes("xls")
  ) {
    return { bg: "bg-[#34AE2B]", border: "border-[#34AE2B]", label: "XLS" };
  }

  if (
    t.includes("wordprocessingml") ||
    t.includes("msword") ||
    t.includes("document") ||
    t.includes("docx") ||
    t.includes("doc")
  ) {
    return { bg: "bg-[#2A99FF]", border: "border-[#2A99FF]", label: "DOC" };
  }

  if (
    t.includes("image") ||
    t.includes("png") ||
    t.includes("jpg") ||
    t.includes("jpeg") ||
    t.includes("gif") ||
    t.includes("webp")
  ) {
    return { bg: "bg-[#FF9900]", border: "border-[#FF9900]", label: "IMG" };
  }

  return { bg: "bg-[#646262]", border: "border-[#646262]", label: "FILE" };
};

const formatFileSize = (bytes) => {
  if (!bytes) return "-";

  const b = parseInt(bytes, 10);

  if (Number.isNaN(b)) return "-";
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;

  return `${(b / (1024 * 1024)).toFixed(1)} MB`;
};

const SortIcon = ({ order }) => {
  if (order === "A") {
    return (
      <Tooltip
        placement="top"
        title="Ascending"
        overlayStyle={{ pointerEvents: "none" }}
        color="white"
        overlayInnerStyle={{ color: "#1F487C" }}
      >
        <TiArrowSortedUp />
      </Tooltip>
    );
  }

  if (order === "D") {
    return (
      <Tooltip
        placement="top"
        title="Descending"
        overlayStyle={{ pointerEvents: "none" }}
        color="white"
        overlayInnerStyle={{ color: "#1F487C" }}
      >
        <TiArrowSortedDown />
      </Tooltip>
    );
  }

  return (
    <Tooltip
      placement="top"
      title="Unsorted"
      overlayStyle={{ pointerEvents: "none" }}
      color="white"
      overlayInnerStyle={{ color: "#1F487C" }}
    >
      <TiArrowUnsorted />
    </Tooltip>
  );
};

const Documents = ({
  searchValue,
  typeFilter,
  categoryFilter,
  viewMode,
  refreshKey,
  openDocumentModal,
}) => {
  const dispatch = useDispatch();
  const categoryId = categoryFilter?.category_id || "";
const subcategoryId = categoryFilter?.subcategory_id || "";
  const documentsData = useSelector((state) => state.crm?.documents_list || []);
  const pageContext = useSelector(
    (state) => state.crm?.documents_page_context || {},
  );

  const [activePage, setActivePage] = useState(1);
  const [sortColumn, setSortColumn] = useState("document_id");
  const [sortOrder, setSortOrder] = useState("D");

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);

  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [otpDocument, setOtpDocument] = useState(null);
  const [hoverId, setHoverId] = useState("");

  const [otpActionType, setOtpActionType] = useState("");
  const [otpTargetDoc, setOtpTargetDoc] = useState(null);

  const [shareModalIsOpen, setShareModalIsOpen] = useState(false);
  const [selectedShareDoc, setSelectedShareDoc] = useState(null);
  console.log(selectedShareDoc,"selectedShareDoc");
  
  const formatDate = (date) => {
    if (!date) return "-";
    return dayjs(date).format("DD MMM, YY");
  };

  const getFileIcon = (type) => {
    const t = String(type || "").toLowerCase();

    if (t.includes("pdf")) {
      return <FaFilePdf size={"3.5vw"} color="#FD3434" />;
    }
    if(t.includes("x-zip-compressed")){
      return <FaFileZipper size="3.5vw" className="text-violet-600" />; 
    }

    if (
      t.includes("spreadsheet") ||
      t.includes("excel") ||
      t.includes("xlsx") ||
      t.includes("xls")
    ) {
      return <FaFileExcel size={"3.5vw"} color="#34AE2B" />;
    }

    if (
      t.includes("wordprocessingml") ||
      t.includes("msword") ||
      t.includes("document") ||
      t.includes("docx") ||
      t.includes("doc")
    ) {
      return <FaFileWord size={"3.5vw"} color="#2A99FF" />;
    }

    if (
      t.includes("image") ||
      t.includes("png") ||
      t.includes("jpg") ||
      t.includes("jpeg")
    ) {
      return <FaFileImage size={"3.5vw"} color="#FF9900" />;
    }

    return <FaFileAlt size={"3.5vw"} color="#A9A9A9" />;
  };

  const currentData = documentsData;

const fetchData = useCallback(
  (page = 1, column = sortColumn, order = sortOrder) => {
    GetDocumentsData({
      dispatch,
      page,
      limit: ITEMS_PER_PAGE,
      search: searchValue,
      type_filter: typeFilter,
      category_id: categoryId,
      subcategory_id: subcategoryId,
      sort_column: column,
      sort_order: order,
    });
  },
  [
    dispatch,
    searchValue,
    typeFilter,
    categoryId,
    subcategoryId,
    sortColumn,
    sortOrder,
  ],
);

  useEffect(() => {
    setActivePage(1);
    fetchData(1);
  }, [searchValue, typeFilter, refreshKey, sortColumn, sortOrder, fetchData]);

  const handlePageChange = (page) => {
    setActivePage(page);
    fetchData(page);
  };

const handleApiSort = (column) => {
  setActivePage(1);

  // first click: ascending
  if (sortColumn !== column) {
    setSortColumn(column);
    setSortOrder("A");
    return;
  }

  // second click: descending
  if (sortOrder === "A") {
    setSortOrder("D");
    return;
  }

  // third click: unsorted/default
  setSortColumn("document_id");
  setSortOrder("D");
};
  const renderSortButton = (column) => (
    <button onClick={() => handleApiSort(column)}>
      <SortIcon order={sortColumn === column ? sortOrder : null} />
    </button>
  );

  const getUserId = () => {
    return (
      sessionStorage.getItem("USER_ID") ||
      localStorage.getItem("USER_ID") ||
      "0001"
    );
  };

  const downloadBlob = (blob, fileName = "document") => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName || "document";
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleDocumentDownload = async (doc) => {
    if (!doc?.document_id) return;

    const response = await RequestOtpForViewSensitiveDocument({
      user_id: getUserId(),
      document_id: doc.document_id,
    });

    if (response?.action === "OTP_REQUIRED") {
      setOtpTargetDoc(doc);
      setOtpActionType("download_document");
      setOtpModalOpen(true);
      return;
    }

    if (response?.blob) {
      downloadBlob(response.blob, doc?.original_file_name);
    }
  };

  const handleToggleFavorite = async (row) => {
    await UpdateDocumentFavorite(row, !row?.is_favorite);
    fetchData(activePage);
  };

  const handleToggleSensitive = async (row) => {
    const nextStatus = !row?.is_sensitive;

    const response = await UpdateDocumentSensitive(row, nextStatus);

    if (response?.action === "OTP_REQUIRED") {
      setOtpTargetDoc(row);
      setOtpActionType("make_nonsensitive");
      setOtpModalOpen(true);
      return;
    }

    fetchData(activePage);
  };

  const handleOtpVerifySuccess = async (encryptedOtp) => {
    if (!otpTargetDoc?.document_id) return;

    if (otpActionType === "download_document") {
      const response = await ValidateDocumentOtp({
        user_id: getUserId(),
        document_id: otpTargetDoc.document_id,
        otp: encryptedOtp,
      });

      if (response?.blob) {
        downloadBlob(response.blob, otpTargetDoc?.original_file_name);
        setOtpModalOpen(false);
        setOtpTargetDoc(null);
        setOtpActionType("");
      }

      return;
    }

    if (otpActionType === "delete_document") {
      const response = await ValidateDeleteDocumentOtp(
        otpTargetDoc.document_id,
        encryptedOtp,
      );

      if (response) {
        setOtpModalOpen(false);
        setOtpTargetDoc(null);
        setOtpActionType("");
        fetchData(activePage);
      }

      return;
    }

    if (otpActionType === "make_nonsensitive") {
      const response = await ValidateUpdateSensitiveStatusOtp(
        otpTargetDoc.document_id,
        encryptedOtp,
      );

      if (response) {
        setOtpModalOpen(false);
        setOtpTargetDoc(null);
        setOtpActionType("");
        fetchData(activePage);
      }
    }
  };

  const isExpiredDocument = (row) => {
    if (!row?.expires_at) return false;
    return dayjs(row.expires_at).isBefore(dayjs().startOf("day"));
  };

  const renderGridNoData = () => (
    <div className="grid grid-cols-1 mt-[15vw]">
      <div className="col-span-1 flex items-center justify-center text-gray-500">
        <img src={NoData} className="w-[3.5vw] h-[3.5vw]" alt="no data" />
      </div>
      <div className="col-span-1 flex items-center justify-center font-medium text-[2vw] mt-[0.5vw] text-gray-500">
        No Data Found
      </div>
    </div>
  );

  const columns = [
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          S.No
        </h1>
      ),
      width: "4vw",
      render: (_, __, index) => {
        const serial = (activePage - 1) * ITEMS_PER_PAGE + (index + 1);

        return (
          <h1 className="flex justify-center font-bold items-center text-[1vw] text-[#1F487C]">
            {serial}
          </h1>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          Name
        </h1>
      ),
      width: "24vw",
      render: (row) => (
        <div className="flex items-center justify-center gap-[0.4vw]">
          {row?.original_file_name?.length > 27 ? (
            <Tooltip
              placement="top"
              title={row.original_file_name}
              className="cursor-pointer text-[#1F487C]"
              color="white"
              overlayInnerStyle={{ color: "#1F487C" }}
            >
              <p className="text-[1vw] font-bold text-[#1F487C]">
                {`${row.original_file_name.slice(0, 22)}...`}
              </p>
            </Tooltip>
          ) : (
            <p className="text-[1vw] font-bold text-[#1F487C]">
              {row.original_file_name || "-"}
            </p>
          )}
        </div>
      ),
    },
    {
  title: (
    <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
      Category
    </h1>
  ),
  width: "11vw",
render: (row) => {
  const categoryName =
    row?.category_name === "deleted_category" ? "" : row?.category_name;

  return (
    <div className="flex items-center justify-center">
      {categoryName?.length > 15 ? (
        <Tooltip
          placement="top"
          title={categoryName}
          className="cursor-pointer text-[#1F487C]"
          color="white"
          overlayInnerStyle={{ color: "#1F487C" }}
        >
          <p className="text-[1vw] font-bold text-[#1F487C]">
            {`${categoryName.slice(0, 15)}...`}
          </p>
        </Tooltip>
      ) : (
        <p className="text-[1vw] font-bold text-[#1F487C]">
          {categoryName || "-"}
        </p>
      )}
    </div>
  );
},
},
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          Type
        </h1>
      ),
      width: "12vw",
      render: (row) => {
        const { bg, border, label } = fileTypeColor(row.file_type);

        return (
          <div className="flex items-center justify-center">
            <div className={``}>
              {label === "ZIP" && <FaFileZipper size="1.5vw" className="text-violet-600" />}
              {label === "PDF" && <FaFilePdf size="1.5vw" color="#FD3434" />}
              {label === "XLS" && <FaFileExcel size="1.5vw" color="#34AE2B" />}
              {label === "DOC" && <FaFileWord size="1.5vw" color="#2A99FF" />}
              {label === "IMG" && <FaFileImage size="1.5vw" color="#FF9900" />}
              {label === "FILE" && <FaFileAlt size="1.5vw" color="#A9A9A9" />}
            </div>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          Size
        </h1>
      ),
      width: "10vw",
      render: (row) => (
        <p className="text-[1vw] font-bold text-[#1F487C] flex items-center justify-center">
          {formatFileSize(row.file_size)}
        </p>
      ),
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-evenly">
          Expires
          {renderSortButton("expires_at")}
        </h1>
      ),
      width: "14vw",
      render: (row) => {
        const expired = isExpiredDocument(row);

        return (
          <p
            className={`text-[1vw] flex items-center justify-center ${
              expired ? "text-[#FD3434] font-bold" : "text-[#1F487C]"
            }`}
          >
            {expired
              ? "Expired"
              : row.expires_at
                ? dayjs(row.expires_at).format("DD MMM, YY")
                : "-"}
          </p>
        );
      },
    },
    // {
    //   title: (
    //     <h1 className="text-[1.1vw] font-bold flex items-center justify-evenly">
    //       Updated
    //       {renderSortButton("updated_at")}
    //     </h1>
    //   ),
    //   width: "13vw",
    //   render: (row) => (
    //     <p className="text-[1vw] text-[#1F487C] flex items-center justify-center">
    //       {row.updatedAgo || "-"}
    //     </p>
    //   ),
    // },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-evenly">
          Updated
          {renderSortButton("updated_at")}
        </h1>
      ),
      width: "12vw",
      render: (row) => (
        <div className="flex items-center justify-center">
          <p className="text-[1vw] text-[#1F487C]">
            {formatDate(row?.updated_at)}
          </p>
        </div>
      ),
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold text-center flex items-center justify-center">
          Actions
        </h1>
      ),
      width: "15vw",
      render: (row) => (
        <div className="grid grid-cols-6 gap-[0.35vw] items-center justify-center px-[1vw]">
          <Tooltip
            title="Download"
            color="white"
            overlayInnerStyle={{ color: "#1F487C" }}
          >
            <MdOutlineFileDownload
              size={"1.25vw"}
              color="#1F4B7F"
              className="cursor-pointer"
              onClick={() => handleDocumentDownload(row)}
            />
          </Tooltip>

          <Tooltip
            title="Edit"
            color="white"
            overlayInnerStyle={{ color: "#1F487C" }}
          >
            <MdEdit
              size={"1.25vw"}
              color="#1F4B7F"
              className="cursor-pointer"
              onClick={() => openDocumentModal("edit", row.document_id)}
            />
          </Tooltip>

          <Tooltip
            title="Delete"
            color="white"
            overlayInnerStyle={{ color: "#1F487C" }}
          >
            <MdDelete
              size={"1.25vw"}
              color="#1F4B7F"
              className="cursor-pointer"
              onClick={async () => {
                setSelectedDoc(row);

                if (row?.is_sensitive) {
                  const response = await DeleteDocument(row.document_id);

                  if (response?.action === "OTP_REQUIRED") {
                    setOtpTargetDoc(row);
                    setOtpActionType("delete_document");
                    setOtpModalOpen(true);
                  }

                  return;
                }

                setDeleteModalOpen(true);
              }}
            />
          </Tooltip>

          <Tooltip
            title={row?.is_favorite ? "Unpin" : "Pin"}
            color="white"
            overlayInnerStyle={{ color: "#1F487C" }}
          >
            {row?.is_favorite ? (
              <BsPinAngleFill
                size="1.25vw"
                color="#1F4B7F" // Blue = Pinned
                className="cursor-pointer"
                onClick={() => handleToggleFavorite(row)}
              />
            ) : (
              <BsPinAngleFill
                size="1.25vw"
                color="#9CA3AF" // Grey = Unpinned
                className="cursor-pointer"
                onClick={() => handleToggleFavorite(row)}
              />
            )}
          </Tooltip>

          <Tooltip
            title={row?.is_sensitive ? "Unlock" : "Lock"}
            color="white"
            overlayInnerStyle={{ color: "#1F487C" }}
          >
            {row?.is_sensitive ? (
              <FaLock
                size="1.1vw"
                color="#1F4B7F" // Blue = Locked
                className="cursor-pointer"
                onClick={() => handleToggleSensitive(row)}
              />
            ) : (
              <FaLockOpen
                size="1.1vw"
                color="#9CA3AF" // Grey = Unlocked
                className="cursor-pointer"
                onClick={() => handleToggleSensitive(row)}
              />
            )}
          </Tooltip>
          <Tooltip
            title="Share"
            color="white"
            overlayInnerStyle={{ color: "#1F487C" }}
          >
            <IoMdShareAlt
              size={"1.25vw"}
              color="#1F4B7F"
              className="cursor-pointer"
              onClick={() => {
                setSelectedShareDoc(row);
                setShareModalIsOpen(true);
              }}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const renderGrid = () => {
    if (!currentData || currentData.length === 0) {
      return renderGridNoData();
    }

    return (
      <div className="pt-[0.5vw]">
        <div className="grid grid-cols-5 w-full gap-x-[4vw] gap-[0.75vw]">
          {currentData.map((item) => {
            const { bg, border, label } = fileTypeColor(item.file_type);
            const expired = isExpiredDocument(item);

            return (
              <div
                key={item.document_id}
                className="bg-white text-[#1f4b7f] h-[16vw] relative border-[#1f4b7f] border-l-[0.1vw] cursor-default border-r-[0.3vw] border-b-[0.3vw] border-t-[0.1vw] rounded-[0.5vw]"
                onMouseEnter={() => setHoverId(item.document_id)}
                onMouseLeave={() => setHoverId("")}
                style={{
                  transition: "ease-in 0.2s",
                  boxShadow:
                    hoverId === item.document_id
                      ? "0.5vw 0.5vw 0.5vw #1f4b7f"
                      : "none",
                }}
              >
                <div className="flex-col flex items-center h-full w-full gap-y-[0.1vw] px-[0.7vw] mt-[0.5vw]">
                  <div className="flex flex-col items-center justify-center w-auto px-[1vw] h-[4.8vw] relative">
                    {getFileIcon(item.file_type)}

                    <div className="absolute top-[0vw] right-[-0.6vw]">
                      {/* {item?.is_sensitive ? (
                        <FaLock size="0.8vw" color="#1F487C" />
                      ) : (
                        <FaLockOpen size="0.8vw" color="#1F487C" />
                      )} */}
                    </div>
                  </div>

                  <div className="flex flex-col w-full items-center justify-center gap-y-[0.25vw] mt-[0.1vw]">
                    <div className="font-bold text-[0.9vw] text-center max-w-full">
                      {item?.original_file_name?.length > 18 ? (
                        <Tooltip
                          placement="top"
                          title={item.original_file_name}
                          color="white"
                          overlayInnerStyle={{ color: "#1F487C" }}
                        >
                          <span className="cursor-pointer">
                            {`${item.original_file_name.slice(0, 18)}...`}
                          </span>
                        </Tooltip>
                      ) : (
                        item.original_file_name || "-"
                      )}
                    </div>

                    <div className="text-[0.9vw] flex">
                      <span className="font-semibold pr-[0.5vw]">Type:</span>
                      <span>{label}</span>
                    </div>

                    <div className="text-[0.9vw] flex">
                      <span className="font-semibold pr-[0.5vw]">Size:</span>
                      <span>{formatFileSize(item.file_size)}</span>
                    </div>

                    <div className="text-[0.9vw] flex">
                      <span className="font-semibold pr-[0.5vw]">Expires:</span>
                      <span
                        className={
                          expired
                            ? "text-[#FD3434] font-semibold"
                            : "text-[#1F487C]"
                        }
                      >
                        {expired
                          ? "Expired"
                          : item.expires_at
                            ? dayjs(item.expires_at).format("MMM DD")
                            : "-"}
                      </span>
                    </div>

                    <div className="px-[0.7vw] w-full flex justify-center mt-[0.3vw]">
                      <div className="flex items-center justify-center gap-[0.45vw]">
                        <Tooltip
                          title="Download"
                          color="white"
                          overlayInnerStyle={{ color: "#1F487C" }}
                        >
                          <div
                            className="w-[1.7vw] h-[1.7vw] rounded-[0.35vw] bg-[#1F487C] flex items-center justify-center shadow-md cursor-pointer"
                            onClick={() => handleDocumentDownload(item)}
                          >
                            <MdOutlineFileDownload size="1vw" color="#FFFFFF" />
                          </div>
                        </Tooltip>

                        <Tooltip
                          title="Edit"
                          color="white"
                          overlayInnerStyle={{ color: "#1F487C" }}
                        >
                          <div
                            className="w-[1.7vw] h-[1.7vw] rounded-[0.35vw] bg-[#1F487C] flex items-center justify-center shadow-md cursor-pointer"
                            onClick={() =>
                              openDocumentModal("edit", item.document_id)
                            }
                          >
                            <MdEdit size="1vw" color="#FFFFFF" />
                          </div>
                        </Tooltip>

                        <Tooltip
                          title="Delete"
                          color="white"
                          overlayInnerStyle={{ color: "#1F487C" }}
                        >
                          <div
                            className="w-[1.7vw] h-[1.7vw] rounded-[0.35vw] bg-[#1F487C] flex items-center justify-center shadow-md cursor-pointer"
                            onClick={async () => {
                              setSelectedDoc(item);

                              if (item?.is_sensitive) {
                                const response = await DeleteDocument(
                                  item.document_id,
                                );

                                if (response?.action === "OTP_REQUIRED") {
                                  setOtpTargetDoc(item);
                                  setOtpActionType("delete_document");
                                  setOtpModalOpen(true);
                                }

                                return;
                              }

                              setDeleteModalOpen(true);
                            }}
                          >
                            <MdDelete size="1vw" color="#FFFFFF" />
                          </div>
                        </Tooltip>

                        <Tooltip
                          title={item?.is_favorite ? "Unpin" : "Pin"}
                          color="white"
                          overlayInnerStyle={{ color: "#1F487C" }}
                        >
                          <div
                            className={`w-[1.7vw] h-[1.7vw] rounded-[0.35vw] ${
                              item?.is_favorite
                                ? "bg-[#1F487C]"
                                : "bg-[#9CA3AF]"
                            } flex items-center justify-center shadow-md cursor-pointer`}
                            onClick={() => handleToggleFavorite(item)}
                          >
                            <BsPinAngleFill size="1vw" color="#FFFFFF" />
                          </div>
                        </Tooltip>

                        <Tooltip
                          title={item?.is_sensitive ? "Unlock" : "Lock"}
                          color="white"
                          overlayInnerStyle={{ color: "#1F487C" }}
                        >
                          <div
                            className={`w-[1.7vw] h-[1.7vw] rounded-[0.35vw] ${
                              item?.is_sensitive
                                ? "bg-[#1F487C]"
                                : "bg-[#9CA3AF]"
                            } flex items-center justify-center shadow-md cursor-pointer`}
                            onClick={() => handleToggleSensitive(item)}
                          >
                            {item?.is_sensitive ? (
                              <FaLock size="0.9vw" color="#FFFFFF" />
                            ) : (
                              <FaLockOpen size="0.9vw" color="#FFFFFF" />
                            )}
                          </div>
                        </Tooltip>
                        <Tooltip
                          title="Share"
                          color="white"
                          overlayInnerStyle={{ color: "#1F487C" }}
                        >
                          <div
                            className="w-[1.7vw] h-[1.7vw] rounded-[0.35vw] bg-[#1F487C] flex items-center justify-center shadow-md cursor-pointer"
                            onClick={() => {
                              setSelectedShareDoc(item);
                              setShareModalIsOpen(true);
                            }}
                          >
                            <IoMdShareAlt size="1vw" color="#FFFFFF" />
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="h-[72vh] w-full">
        {viewMode === "grid" ? (
          currentData?.length > 0 ? (
            renderGrid()
          ) : (
            renderGridNoData()
          )
        ) : (
          <Table
            dataSource={currentData}
            columns={columns}
            rowKey="document_id"
            pagination={false}
            className="custom-table"
          />
        )}
      </div>

      {pageContext?.total > ITEMS_PER_PAGE && (
        <div className="w-full h-[8vh] flex justify-between items-center">
          <div className="text-[#1F487C] flex text-[1.1vw] gap-[0.5vw]">
            <span>Showing</span>

            <span className="font-bold">
              {currentData && currentData.length > 0 ? (
                <div>
                  {(activePage - 1) * ITEMS_PER_PAGE + 1} -{" "}
                  {(activePage - 1) * ITEMS_PER_PAGE + currentData.length}
                </div>
              ) : (
                "0"
              )}
            </span>

            <span>from</span>

            <span className="font-bold">{pageContext?.total || 0}</span>

            <span>data</span>
          </div>

          <div>
            <ReactPaginate
              activePage={activePage}
              itemsCountPerPage={ITEMS_PER_PAGE}
              totalItemsCount={pageContext?.total || 0}
              pageRangeDisplayed={3}
              onChange={handlePageChange}
              itemClass="page-item"
              linkClass="page-link"
              activeClass="active"
              prevPageText={<FontAwesomeIcon icon={faChevronLeft} size="1vw" />}
              nextPageText={
                <FontAwesomeIcon icon={faChevronRight} size="1vw" />
              }
              firstPageText={
                <FontAwesomeIcon icon={faAngleDoubleLeft} size="1vw" />
              }
              lastPageText={
                <FontAwesomeIcon icon={faAngleDoubleRight} size="1vw" />
              }
            />
          </div>
        </div>
      )}

      <ModalPopup
        show={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        height="20vw"
        width="30vw"
        closeicon={false}
      >
        <DocumentDeleteList
          setDeleteModalIsOpen={setDeleteModalOpen}
          content={"Want to delete this"}
          title={selectedDoc?.original_file_name}
          api={selectedDoc?.document_id}
         filter={{
  page: activePage,
  limit: ITEMS_PER_PAGE,
  type_filter: typeFilter,
  category_id: categoryId,
  subcategory_id: subcategoryId,
  search: searchValue,
  sort_column: sortColumn,
  sort_order: sortOrder,
}}
        />
      </ModalPopup>

      <DocumentOtpModal
        show={otpModalOpen}
        onClose={() => {
          setOtpModalOpen(false);
          setOtpTargetDoc(null);
          setOtpActionType("");
        }}
        document={otpTargetDoc}
        actionType={otpActionType}
        onVerifySuccess={handleOtpVerifySuccess}
        resendOtp={async (doc) => {
          if (otpActionType === "download_document") {
            return await RequestOtpForViewSensitiveDocument({
              user_id: getUserId(),
              document_id: doc.document_id,
            });
          }

          if (otpActionType === "delete_document") {
            return await DeleteDocument(doc.document_id);
          }

          if (otpActionType === "make_nonsensitive") {
            return await UpdateDocumentSensitive(doc, false);
          }

          return null;
        }}
      />
      <ShareModal
        show={shareModalIsOpen}
        onClose={() => {
          setShareModalIsOpen(false);
          setSelectedShareDoc(null);
        }}
        previewContent={
          <div>
            <div className="flex gap-1">
              <p className="font-semibold">Document Name:</p>
              <p>{selectedShareDoc?.original_file_name || "-"}</p>
            </div>
            <div className="flex gap-1">
              <p className="font-semibold">Type:</p>
              <p>{selectedShareDoc?.file_type.includes("sheet") ? "Sheet" : selectedShareDoc?.file_type.includes("document") ? "Word Document" : `${selectedShareDoc?.file_type}`}</p>
            </div>
            {/* <div className="mt-[0.5vw]">
              <p className="font-semibold">Sensitive</p>
              <p>{selectedShareDoc?.is_sensitive ? "Yes" : "No"}</p>
            </div> */}
          </div>
        }
        module="documents"
        id={selectedShareDoc?.document_id}
        isSens={selectedShareDoc?.is_sensitive}
      />
    </>
  );
};

export default Documents;
